import { Injectable } from '@angular/core';
import { CoveragePremiumInterface, Response } from '@app/core/interfaces';
import { RequestService } from 'outshared-lib';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

/** @deprecated use outshared-lib - InsurancePolicyActionService / InsurancePolicyDataService */
@Injectable({
    providedIn: 'root',
})
export class CalculationService {

    constructor(
        private requestService: RequestService,
    ) {}

    /** @deprecated use outshared-lib - InsurancePolicyActionService / InsurancePolicyDataService */
    public calculateCoveragePremiumPurchasedProduct(
        props: { purchased_product_sequence_number: number },
    ): Observable<CoveragePremiumInterface> {
        const { purchased_product_sequence_number } = props;
        const payload = {
            purchased_product: {
                purchased_product_sequence_number,
            },
        };

        return this.requestService.post('en-gb/insurance-coverage/calculate/coverage-premium-purchased_product', payload).pipe(
            map((result) => result.data),
            map((calculation) => this.patchDefaultCoverageValues(calculation)),
            map((calculation) => this.addPremiumTax(calculation)),
            map((calculation) => {
                calculation.product.base_coverages =
                    calculation.product.base_coverages.filter((item) => item.coverage_id !== 'DISA');
                return calculation;
            }),
        );
    }

    /** @deprecated use outshared-lib - InsurancePolicyActionService / InsurancePolicyDataService */
    public changeGenericPurchasedCoverages(props: {
        purchased_product_sequence_number: number,
        start_date: string,
        coverage_ids: {
            coverage_id: string,
        }[],
        product_id: string,
    }): Observable<Response> {
        const { purchased_product_sequence_number, start_date, coverage_ids, product_id } = props;
        const payload = {
            purchased_product: {
                purchased_product_sequence_number,
            },
            claim_coverage: {
                start_date,
                coverages: coverage_ids,
            },
            premium_factor: {
                campaign_code: null,
            },
        };

        if (product_id === 'AUTO') {
            payload.claim_coverage.coverages = [
                ...payload.claim_coverage.coverages,
                { coverage_id: 'DISA' },
            ];
        }

        return this.requestService.post('en-gb/insurance-coverage/change_generic/purchasedcoverages', payload);
    }

    /** @deprecated use outshared-lib - InsurancePolicyActionService / InsurancePolicyDataService */
    public cancelFuturePurchasedCoverage$(props: { purchased_product_sequence_number: number }): Observable<Response> {
        const { purchased_product_sequence_number } = props;
        const payload = {
            purchased_product: {
                purchased_product_sequence_number,
            },
        };

        return this.requestService.post('en-gb/insurance-coverage/cancel/future-purchased_coverage', payload);
    }

    /** @deprecated use outshared-lib - InsurancePolicyActionService / InsurancePolicyDataService */
    private patchDefaultCoverageValues(calculation: CoveragePremiumInterface): CoveragePremiumInterface {
        const keys = ['total_premium', 'total_discount', 'total_premium_including_discount'];

        keys.forEach((key) => {
            calculation.product[key] = {
                basic_premium: 0,
                premium: 0,
                premium_including_premium_tax: 0,
                premium_tax: 0,
            };
        });

        return calculation;
    }

    /** @deprecated use outshared-lib - InsurancePolicyActionService / InsurancePolicyDataService */
    private addPremiumTax(calculation: CoveragePremiumInterface): CoveragePremiumInterface {
        const { product } = calculation;
        const base_coverages = product.base_coverages ? product.base_coverages : [];
        const additional_coverage = product.additional_coverage ? product.additional_coverage : [];
        const coverages = [...base_coverages, ...additional_coverage];

        coverages.forEach((coverage) => {
            if (!coverage.purchased_coverage) {
                return;
            }

            if (coverage.premium) {
                product.total_premium.premium_including_premium_tax
                    += coverage.premium.premium_including_premium_tax;
            }

            if (coverage.discount) {
                product.total_discount.premium_including_premium_tax
                    += coverage.discount.premium_including_premium_tax;
            }

            if (coverage.premium_including_discount) {
                product.total_premium_including_discount.premium_including_premium_tax
                    += coverage.premium_including_discount.premium_including_premium_tax;
            }
        });

        return Object.assign({}, calculation, { product });
    }
}
